import { FC } from 'react';
import { Button } from '@edikk-edikk/country-layout-black';
import { FormattedMessage } from 'react-intl';
import { useMenuButtonVariant } from '#baseMenu/components';

const LinkToManage: FC = () => {
  const buttonVariant = useMenuButtonVariant();

  return (
    <Button
      linkSimpleProps={{ href: '/manage' }}
      variant={buttonVariant}
      pill
      textUppercase
      additionalClassName="flex-grow-1"
    >
      <FormattedMessage defaultMessage="Advertise" />
    </Button>
  );
};

export { LinkToManage };
